/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Panel, Row, Col } from 'react-bootstrap';
import PieChart from 'loracoms/PieChart';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const kLabel = {
  normal: {
    formatter: '{b}\n{d}%',
  },
  emphasis: {
    formatter: '{b}\n{d}%',
  },
};

const klabelLine = {
  normal: {
    length: 5,
    length2: 5,
  },
};

const kLabelPosition = {
  color: '#34495e',
  normal: {
    position: 'inside',
  },
};

const kItemUsed = {
  normal: {
    color: '#59abe3',
  },
};

const kItemFree = {
  normal: {
    color: '#f4b350',
  },
};

const propTypes = {
  intl: intlShape.isRequired,
  status: PropTypes.string.isRequired,
  gatewayStatus: PropTypes.object.isRequired,
};

class Pies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      channelSeries: [],
      serviceSeries: [],
      status: props.status,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.gateway.channel');
  }

  componentWillReceiveProps({ status, gatewayStatus }) {
    if (status !== this.props.status) {
      this.setState({ status });
    }
    if (!_.isEqual(gatewayStatus, this.props.gatewayStatus)) {
      this.initSeries(gatewayStatus);
    }
  }

  initSeries(gatewayStatus) {
    if (!gatewayStatus.channels) return;

    const channelSeries = _.map(gatewayStatus.channels, (c) => {
      const name = `${this.intlMsg.msg('header')}${c.channel}`;
      const used = _.reduce(c.services, (sum, n) => sum + n.used, 0);
      const free = _.reduce(c.services, (sum, n) => sum + n.free, 0);
      return {
        name,
        series: [{
          name: this.intlMsg.msg('pie.used'),
          value: used,
          itemStyle: kItemUsed,
          label: kLabelPosition,
          labelLine: klabelLine,
        }, {
          name: this.intlMsg.msg('pie.free'),
          value: free,
          itemStyle: kItemFree,
          label: kLabelPosition,
        }],
      };
    });

    const services = _.reduce(gatewayStatus.channels, (c, n) => _.concat(c, n.services), []);
    const g = _.groupBy(services, 'service');
    const serviceSeries = _.map(_.keys(g), (k) => {
      const ss = g[k];
      const name = `${this.intlMsg.msg('pie.service')}${k}`;
      const used = _.reduce(ss, (sum, n) => sum + n.used, 0);
      const free = _.reduce(ss, (sum, n) => sum + n.free, 0);
      return {
        name,
        series: [{
          name: this.intlMsg.msg('pie.used'),
          value: used,
          itemStyle: kItemUsed,
          label: kLabelPosition,
          labelLine: klabelLine,
        }, {
          name: this.intlMsg.msg('pie.free'),
          value: free,
          itemStyle: kItemFree,
          label: kLabelPosition,
        }],
      };
    });
    this.setState({ channelSeries, serviceSeries });
  }

  render() {
    const {
      channelSeries,
      serviceSeries,
    } = this.state;
    return (
      <Panel
        bsStyle="aisz-white" header={this.intlMsg.msg('pie.header')}
      >
        <Row>
          {_.map(channelSeries, (c, idx) => (
            <Col md={4} key={String(idx)}>
              <div className={styles.hpie}>{c.name}</div>
              <PieChart
                height={200}
                series={[{
                  label: kLabel,
                  data: c.series,
                }]}
              />
            </Col>
          ))}
        </Row>
        <Row>
          {_.map(serviceSeries, (c, idx) => (
            <Col md={4} key={String(idx)}>
              <div className={styles.hpie}>{c.name}</div>
              <PieChart
                height={200}
                series={[{
                  label: kLabel,
                  data: c.series,
                }]}
              />
            </Col>
          ))}
        </Row>
      </Panel>
    );
  }
}

Pies.propTypes = propTypes;

export default injectIntl(Pies);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/GatewayStatus/Pies.jsx